export const resizeImageURL = (imageUrl: string, size = 52): string => {
  const imgPath = imageUrl.substring(0, imageUrl.lastIndexOf('.'));
  const imgext = imageUrl.split('.').pop();

  return imgPath.includes(`_${size}x${size}`)
    ? `${imgPath}.${imgext}.webp`
    : `${imgPath}_${size}x${size}.${imgext}.webp`;
};
